module.exports = __webpack_public_path__ + "media/Loops 90 Vocals.b4344f49.wav";